import { cn } from "@tellescope/utils";
import type { FormCustomization } from "@tellescope/types-models";

const ALIGNMENT_CLASS: Record<NonNullable<FormCustomization["logoAlignment"]>, string> = {
  left: "justify-start",
  center: "justify-center",
  right: "justify-end",
};

export interface FormWizardLogoProps {
  formLogoURL?: string;
  orgLogoSrc?: string;
  orgName?: string;
  logoHeight?: number;
  logoAlignment?: FormCustomization["logoAlignment"];
}

/**
 * The logo strip above the form body.
 *
 * Resolution order matches legacy (`forms.tsx:44-61`): the form's own `customization.logoURL` wins
 * over the organization logo, and when neither is set the organization *name* renders as text rather
 * than the strip collapsing — an unbranded form still identifies who is asking.
 */
export const FormWizardLogo = ({
  formLogoURL,
  orgLogoSrc,
  orgName,
  logoHeight,
  logoAlignment = "left",
}: FormWizardLogoProps) => {
  const src = formLogoURL || orgLogoSrc;
  if (!src && !orgName) return null;

  return (
    <div className={cn("px-4 pt-4 pb-2 flex flex-shrink-0", ALIGNMENT_CLASS[logoAlignment])}>
      {src ? (
        <img
          src={src}
          alt=""
          className={cn("object-contain", logoHeight === undefined && "h-10")}
          style={logoHeight === undefined ? undefined : { height: logoHeight }}
        />
      ) : (
        <span className="text-lg font-semibold">{orgName}</span>
      )}
    </div>
  );
};
